import { Layer } from "@deck.gl/core";
import { IventisMapboxLayerMetaDataSitemapLayer } from "./mapbox-test-helper-types";

export function isIventis3dSitemapLayer(layer: Layer): layer is Layer<{ metadata: IventisMapboxLayerMetaDataSitemapLayer }> {
    if (layer == null || layer.props == null) {
        return false;
    }

    const hasMetadata = "metadata" in layer.props;
    if (!hasMetadata) {
        return false;
    }

    const { metadata } = layer.props as Layer["props"] & { metadata: Record<string, unknown> };
    return metadata.type === "sitemap" && typeof metadata.sitemapName === "string" && typeof metadata.sitemapVersionName === "string";
}
